(function(){
'use strict';

/* ── Image switcher ── */
var allThumbs=document.querySelectorAll('.ff-gallery__thumb');
var imgs=document.querySelectorAll('.ff-gallery__img');
function switchImg(idx){
  imgs.forEach(function(img,i){img.classList.toggle('ff-h',i!==idx);});
  allThumbs.forEach(function(t){
    var a=parseInt(t.dataset.idx,10)===idx;
    t.classList.toggle('is-active',a);
    t.setAttribute('aria-pressed',String(a));
  });
}
allThumbs.forEach(function(btn){
  btn.addEventListener('click',function(){switchImg(parseInt(this.dataset.idx,10));});
});

/* ── Wishlist heart ── */
var wlBtn=document.getElementById('ff-wl-btn');
if(wlBtn){
  var pid=wlBtn.dataset.productId,KEY='ff_wl_'+pid,saved=false;
  try{saved=localStorage.getItem(KEY)==='1';}catch(e){}
  if(saved)wlBtn.classList.add('is-saved');
  wlBtn.setAttribute('aria-pressed',String(saved));
  wlBtn.addEventListener('click',function(){
    saved=!saved;
    this.classList.toggle('is-saved',saved);
    this.setAttribute('aria-pressed',String(saved));
    this.classList.remove('pop');
    void this.offsetWidth;
    this.classList.add('pop');
    try{if(saved){localStorage.setItem(KEY,'1');}else{localStorage.removeItem(KEY);}}catch(e){}
  });
}

/* ── Tabs ── */
var tabBtns=document.querySelectorAll('.ff-tabs__tab');
var tabPanels=document.querySelectorAll('.ff-tabs__panel');
tabBtns.forEach(function(btn){
  btn.addEventListener('click',function(){
    var target=this.getAttribute('aria-controls');
    tabBtns.forEach(function(b){b.classList.remove('is-active');b.setAttribute('aria-selected','false');});
    tabPanels.forEach(function(p){p.classList.remove('is-active');});
    this.classList.add('is-active');
    this.setAttribute('aria-selected','true');
    var panel=document.getElementById(target);
    if(panel)panel.classList.add('is-active');
  });
});

/* ── Description read-more ── */
requestAnimationFrame(function(){
  var descEl=document.getElementById('ff-desc-inner');
  var descBtn=document.getElementById('ff-desc-more-btn');
  if(descEl&&descBtn){
    var lh=parseFloat(getComputedStyle(descEl).lineHeight)||22;
    if(descEl.scrollHeight>Math.ceil(lh*3.6)){
      descBtn.style.display='';
      descBtn.addEventListener('click',function(){
        var open=descEl.classList.toggle('is-open');
        this.textContent=open?'Read less':'Read more';
      });
    }
  }
});

/* ── Variant selection ── */
var el=document.getElementById('ff-pdp-data');
var variants=JSON.parse(el.dataset.variants||'[]');
var sel=JSON.parse(el.dataset.sel||'[]');
function findV(s){return variants.find(function(v){return s.every(function(x,i){return v['option'+(i+1)]===x;});});}
function gbp(c){return(c/100).toLocaleString('en-GB',{style:'currency',currency:'GBP'});}
function getCurrentVid(){return document.getElementById('ff-vid').value;}

/* ── Buy now ── */
function buyNow(){
  var vid=getCurrentVid();
  if(!vid)return;
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:[{id:parseInt(vid,10),quantity:1}]})})
    .then(function(){window.location.href='/checkout';})
    .catch(function(){window.location.href='/cart';});
}
var buyNowBtn=document.getElementById('ff-buy-now');
if(buyNowBtn)buyNowBtn.addEventListener('click',buyNow);
var stickyBuyBtn=document.getElementById('ff-sticky-buy');
if(stickyBuyBtn)stickyBuyBtn.addEventListener('click',buyNow);

/* ── Option buttons ── */
document.querySelectorAll('.ff-opt__btn').forEach(function(btn){
  btn.addEventListener('click',function(){
    var oi=parseInt(this.dataset.oi,10),val=this.dataset.val;
    sel[oi]=val;
    var lbl=document.getElementById('ff-ov-'+oi);
    if(lbl)lbl.textContent=val;
    document.querySelectorAll('.ff-opt__btn[data-oi="'+oi+'"]').forEach(function(b){
      var s=b.dataset.val===val;
      b.classList.toggle('is-sel',s);
      b.setAttribute('aria-pressed',String(s));
    });
    var v=findV(sel);
    if(!v)return;
    document.getElementById('ff-vid').value=v.id;
    var p=gbp(v.price),hs=v.compare_at_price&&v.compare_at_price>v.price;
    var pb=document.getElementById('ff-price-block');
    if(pb){
      var h='<span class="ff-details__price'+(hs?'':' ff-details__price--full')+'">'+p+'</span>';
      if(hs){
        var pct2=Math.round((v.compare_at_price-v.price)*100/v.compare_at_price);
        h+='<span class="ff-details__compare"><s>'+gbp(v.compare_at_price)+'</s></span><span class="ff-details__saving">Save '+pct2+'%</span>';
      }
      pb.innerHTML=h;
    }
    var sp=document.getElementById('ff-sticky-price');
    if(sp)sp.textContent=p;
    var matChips=document.getElementById('ff-mat-chips');
    var matList=document.getElementById('ff-mat-list');
    if(matChips&&matList){
      var parts=v.title.split(' / '),mat='';
      parts.forEach(function(pt){if(pt.indexOf('%')>-1)mat=pt;});
      if(mat){
        matChips.innerHTML=mat.split('+').map(function(m){
          return '<span class="ff-mat-chip"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>'+m.trim()+'</span>';
        }).join('');
        var fl=matList.querySelector('li');
        if(fl)fl.innerHTML='Material: <strong>'+mat+'</strong>';
      }
    }
    var atc=document.getElementById('ff-atc');
    var bn=document.getElementById('ff-buy-now');
    var avail=v.available;
    if(atc){
      atc.disabled=!avail;
      atc.setAttribute('aria-disabled',String(!avail));
      atc.innerHTML=avail?'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>Add to bag':'Sold out';
    }
    if(bn){
      bn.disabled=!avail;
      bn.setAttribute('aria-disabled',String(!avail));
      bn.textContent=avail?'Buy now':'Sold out';
    }
    var sc=document.getElementById('ff-scarcity');
    if(sc){
      if(v.inventory_quantity>0&&v.inventory_quantity<5){
        sc.textContent='Only '+v.inventory_quantity+' left in your size!';
        sc.classList.add('is-on');
      }else{
        sc.textContent='';
        sc.classList.remove('is-on');
      }
    }
  });
});

/* ── Sticky ATC bar ── */
var atcEl=document.getElementById('ff-atc');
var stickyEl=document.getElementById('ff-sticky');
if(atcEl&&stickyEl&&'IntersectionObserver' in window){
  new IntersectionObserver(function(e){
    var vis=!e[0].isIntersecting;
    stickyEl.classList.toggle('is-on',vis);
    stickyEl.setAttribute('aria-hidden',String(!vis));
  },{rootMargin:'0px 0px -80px 0px'}).observe(atcEl);
}
var sb=document.getElementById('ff-sticky-btn');
if(sb)sb.addEventListener('click',function(){
  var f=document.getElementById('ff-form');
  if(f){f.requestSubmit?f.requestSubmit():f.submit();}
});

/* ── Size guide modal ── */
var overlay=document.getElementById('ff-sg-overlay');
function openSG(){if(!overlay)return;overlay.classList.add('is-on');overlay.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';}
function closeSG(){if(!overlay)return;overlay.classList.remove('is-on');overlay.setAttribute('aria-hidden','true');document.body.style.overflow='';}
var sgO=document.getElementById('ff-sg-open');
var sgC=document.getElementById('ff-sg-close');
if(sgO)sgO.addEventListener('click',openSG);
if(sgC)sgC.addEventListener('click',closeSG);
if(overlay)overlay.addEventListener('click',function(e){if(e.target===overlay)closeSG();});
document.addEventListener('keydown',function(e){if(e.key==='Escape')closeSG();});

/* ── Gallery swipe navigation (mobile) ── */
var _gImgs=document.querySelectorAll('.ff-gallery__img');
var _gTotal=_gImgs.length;
var _gCur=0;
if(_gTotal>1){
  var _gMain=document.getElementById('ff-gallery-main');
  if(_gMain){
    var _pBtn=document.createElement('button');
    _pBtn.className='ff-gal-nav ff-gal-prev';
    _pBtn.setAttribute('aria-label','Previous image');
    _pBtn.innerHTML='<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>';
    var _nBtn=document.createElement('button');
    _nBtn.className='ff-gal-nav ff-gal-next';
    _nBtn.setAttribute('aria-label','Next image');
    _nBtn.innerHTML='<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>';
    var _ctr=document.createElement('div');
    _ctr.className='ff-gal-counter';
    _ctr.setAttribute('aria-live','polite');
    _gMain.appendChild(_pBtn);
    _gMain.appendChild(_nBtn);
    _gMain.appendChild(_ctr);
    function _gGo(i){
      if(i<0||i>=_gTotal)return;
      _gCur=i;
      switchImg(i);
      _pBtn.disabled=i===0;
      _nBtn.disabled=i===_gTotal-1;
      _ctr.textContent=(i+1)+' / '+_gTotal;
    }
    _pBtn.addEventListener('click',function(e){e.stopPropagation();_gGo(_gCur-1);});
    _nBtn.addEventListener('click',function(e){e.stopPropagation();_gGo(_gCur+1);});
    _gGo(0);
    /* Touch swipe — only horizontal swipes navigate; vertical scrolls the page */
    var _swX=0,_swY=0,_swActive=false;
    _gMain.addEventListener('touchstart',function(e){
      _swX=e.touches[0].clientX;
      _swY=e.touches[0].clientY;
      _swActive=true;
    },{passive:true});
    _gMain.addEventListener('touchmove',function(e){
      if(!_swActive)return;
      var dx=Math.abs(e.touches[0].clientX-_swX);
      var dy=Math.abs(e.touches[0].clientY-_swY);
      /* If moving more vertically than horizontally, cancel swipe tracking
         so the page scrolls normally and no accidental navigation occurs */
      if(dy>dx)_swActive=false;
    },{passive:true});
    _gMain.addEventListener('touchend',function(e){
      if(!_swActive)return;
      var dx=e.changedTouches[0].clientX-_swX;
      var dy=e.changedTouches[0].clientY-_swY;
      _swActive=false;
      if(Math.abs(dx)>Math.abs(dy)&&Math.abs(dx)>40){
        _gGo(dx<0?_gCur+1:_gCur-1);
      }
    },{passive:true});
  }
}

})();